import { IAlertConfig } from '../../../../models/bootstrap/Alert' 
import { BusinessArea } from '../../../../services/AuthService';

class AgencyContactModalController {

    isAgencyManagmentAllowed: boolean = false;
    isOfficeUser: boolean = false;

    showMessageText: boolean = false
    alerts: IAlertConfig[] = []

    static $inject = ['$scope', '$uibModalInstance', 'AgencyContact', 'agencyContact', 'Auth', '$timeout']
    constructor(private $scope, private $uibModalInstance, private AgencyContact, private agencyContact, Auth, private $timeout) {

        this.isAgencyManagmentAllowed = Auth.isInBusinessArea(BusinessArea.AGENCY_MANAGEMENT);
        this.isOfficeUser = Auth.user.isOfficer;
    }

    validate() {
        this.$scope.$broadcast('submitted', true)
        return this.agencyContact.$validation();
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel')
    }

    save() {
        if (!this.validate()) {
            return
        }

        this.alerts = [];

        this.AgencyContact.saveAgencyContact({ agencyId: this.agencyContact.agencyId }, this.agencyContact)
            .$promise.then(() => {
                this.$uibModalInstance.close()
            },
                () => {

                    this.alerts.push({
                        type: 'danger',
                        msg: 'We are sorry but your form could not be saved. Please try again in 5 minutes. <br /> If this problem continues, please contact us at: <a target= "_blank" href= "mailto:support@aupairamerica.co.uk" > support@aupairamerica.co.uk</a>',
                        dismissOnTimeout: 5000
                    })
                    this.showMessageText = true;
                    this.$timeout(() => { this.showMessageText = false; }, 5000);
                });

    }
}

angular
    .module('app')
    .controller('AgencyContactModalController', AgencyContactModalController)